/**
 * @generated SignedSource<<cba8f072d503edc36d3e9bfa2a33adb4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavBarButtons_seller$data = {
  readonly createListingOptions: ReadonlyArray<{
    readonly dataTn: string | null;
    readonly text: string | null;
    readonly url: string | null;
  } | null> | null;
  readonly vertical: string | null;
  readonly " $fragmentType": "NavBarButtons_seller";
};
export type NavBarButtons_seller$key = {
  readonly " $data"?: NavBarButtons_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavBarButtons_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavBarButtons_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vertical",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "CreateListingOption",
      "kind": "LinkedField",
      "name": "createListingOptions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dataTn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "2d916e3c0c27f6a0e1e83e5e71c2452e";

export default node;
